import { createContext, useContext, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { unauthenticatedRoutes } from '../OpalRoutes'
import { pathMatchesRoutes } from '../pathMatchesRoutes'

export const BypassAuthenticationContext = createContext<boolean | undefined>(
  undefined
)
BypassAuthenticationContext.displayName = 'BypassAuthenticationContext'

/**
 * Check the current route to see if authentication should be skipped, there
 * are several routes that need to allow an unauthenticated user
 * into the page.
 */
export const BypassAuthenticationProvider = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  const { pathname } = useLocation()

  const bypassAuthentication = useMemo(
    () => pathMatchesRoutes(unauthenticatedRoutes, pathname),
    [pathname]
  )

  return (
    <BypassAuthenticationContext.Provider value={bypassAuthentication}>
      {children}
    </BypassAuthenticationContext.Provider>
  )
}

export const useBypassAuthentication = () =>
  Boolean(useContext(BypassAuthenticationContext))
